// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  name: 'coassess',
  logo: './assets/media/logos/coassess-logo-light.png',
  accessLevels: {
    role: 1 || 2 || 3 || 4,
  },
  appVersion: 'v8.1.7',
  USERDATA_KEY: 'authf649fc9a5f55',
  apiUrl: 'api',
  api: 'https://api.stg.coassess.gr/api/',
  analyzeApi: '/analyze-api',
  reportUrl: 'https://api.stg.coassess.gr/',
  hub: 'https://api.stg.coassess.gr',
  neo4jUri: 'bolt+s://neo4j.bolt.dev.coassess.gr:7687',
  neo4jUser: 'neo4j',
    neo4jPass: 'Q7io0Pml1rTu',
    showEthnikiLogo: false
};
